import { InspectionFormTemplate } from '@rcp/types';
import { RestSlice } from '../../../redux/rest.slice';
import { Resource, localizationService } from 'src/services';

export const inspectionFormTemplatesSlice = new RestSlice<InspectionFormTemplate>(
	localizationService.getLocalizedString('inspectionFormTemplates.title'),
	`Settings/${Resource.InspectionFormTemplates}`
);
export const inspectionFormTemplatesSliceReducer = inspectionFormTemplatesSlice.rests.reducer;
